import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  purchaseInvoiceService,
  PurchaseInvoiceListParams,
  CreatePurchaseInvoiceData,
  RecordPaymentData,
} from '../../services/purchaseInvoices/purchaseInvoiceService'
import { showSuccessToast, showErrorToast } from '../../utils/errorHandler'

export const usePurchaseInvoices = (params?: PurchaseInvoiceListParams) => {
  return useQuery({
    queryKey: ['purchase-invoices', params],
    queryFn: () => purchaseInvoiceService.getPurchaseInvoices(params),
  })
}

export const usePurchaseInvoice = (id: string) => {
  return useQuery({
    queryKey: ['purchase-invoice', id],
    queryFn: () => purchaseInvoiceService.getPurchaseInvoiceById(id),
    enabled: !!id,
  })
}

export const useCreatePurchaseInvoice = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreatePurchaseInvoiceData) =>
      purchaseInvoiceService.createPurchaseInvoice(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['purchase-invoices'] })
      queryClient.invalidateQueries({ queryKey: ['inventory-stock'] })
      queryClient.invalidateQueries({ queryKey: ['stock-ledger'] })
      queryClient.invalidateQueries({ queryKey: ['account-summary'] })
      showSuccessToast('Purchase invoice created successfully!')
    },
    onError: (error: any) => {
      showErrorToast(error)
    },
  })
}

export const useRecordVendorPayment = (id: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: RecordPaymentData) => purchaseInvoiceService.recordPayment(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['purchase-invoices'] })
      queryClient.invalidateQueries({ queryKey: ['purchase-invoice', id] })
      queryClient.invalidateQueries({ queryKey: ['account-ledger'] })
      queryClient.invalidateQueries({ queryKey: ['account-ledger-balance'] })
      queryClient.invalidateQueries({ queryKey: ['account-summary'] })
      showSuccessToast('Payment recorded successfully.')
    },
    onError: (error: any) => {
      showErrorToast(error)
    },
  })
}
